import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Card, Modal } from "react-bootstrap";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";
import "react-big-calendar/lib/css/react-big-calendar.css";
import Layout from "../../../../components/Layouts/Layouts/Layout";
import DashboardHeader from "../../../../components/basic/DashboardHeader";
import { getURLbyEndPointV2 } from "../../../../store/api";

// React Big Calendar Localizer
const locales = {
    "en-US": require("date-fns/locale/en-US"),
};

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
});

const B2bCalender = () => {
    const [slots, setSlots] = useState([]);
    const [calendarEvents, setCalendarEvents] = useState([]);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // Fetch all slots data
    const fetchSlots = async () => {
        try {
            const response = await axios.get(getURLbyEndPointV2("getAllB2bSlots"));
            if (response.status === 200) {
                setSlots(response.data.data);

                // Map slots to calendar events
                const events = response.data.data.map((slot) => ({
                    title: `Slot: ${slot.startTime} - ${slot.endTime}`,
                    start: new Date(slot.date),
                    end: new Date(slot.date),
                    allDay: false,
                    slotData: slot, // Store the slot data for later use
                }));
                setCalendarEvents(events);
            } else {
                alert("Failed to fetch slots data.");
            }
        } catch (error) {
            alert("Error fetching slots data:", error);
        }
    };

    // Handle slot click
    const handleSlotClick = (event) => {
        setSelectedSlot(event.slotData);
        setShowModal(true);
    };

    // Close modal
    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedSlot(null);
    };

    useEffect(() => {
        fetchSlots();
    }, []);

    return (
        <Layout>
            <div className="d-flex flex-column justify-content-center align-items-center px-3">
                <div className="main-width d-flex flex-column">
                    <hr />
                    <DashboardHeader
                        heading="EVENTS / B2B Collaborator Slots"
                        backUrl="/b2b-virtual-forum"
                    />
                    <hr />

                    {/* Calendar */}
                    <div style={{ height: "700px" }}>
                        <Calendar
                            localizer={localizer}
                            events={calendarEvents}
                            startAccessor="start"
                            endAccessor="end"
                            defaultView="month"
                            views={["month", "week", "day"]}
                            onSelectEvent={handleSlotClick} // Handle slot click
                            step={60}
                            timeslots={1}
                        />
                    </div>

                    {/* Slot Details Modal */}
                    <Modal show={showModal} onHide={handleCloseModal} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Slot Details</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {selectedSlot && (
                                <div>
                                    <div>
                                        <strong>Name:</strong> {selectedSlot.clientId?.companyName || "N/A"}
                                    </div>
                                    <div>
                                        <strong>Country:</strong> {selectedSlot.clientId?.country || "N/A"}
                                    </div>
                                    <div>
                                        <strong>Date:</strong> {new Date(selectedSlot.date).toLocaleDateString()}
                                    </div>
                                    <div>
                                        <strong>Time:</strong> {selectedSlot.startTime} - {selectedSlot.endTime}
                                    </div>
                                    <div>
                                        <strong>Duration:</strong> {selectedSlot.duration} minutes
                                    </div>
                                    <div>
                                        <strong>Status:</strong>{" "}
                                        <span
                                            className={`badge ${selectedSlot.isApproved === "Approved"
                                                ? "bg-success"
                                                : selectedSlot.isApproved === "Rejected"
                                                    ? "bg-danger"
                                                    : "bg-warning"
                                                }`}
                                        >
                                            {selectedSlot.isApproved}
                                        </span>
                                    </div>
                                    <div>
                                        <strong>Registered At:</strong>{" "}
                                        {new Date(selectedSlot.bookedAt).toLocaleString()}
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleCloseModal}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </Layout>
    );
};

export default B2bCalender;